import { Controller } from "stimulus";

export default class extends Controller {
  static targets = ['field', 'submit'];

  connect() {
    this.updateSubmit();
  }

  change(ev) {
    this.updateSubmit();
  }

  updateSubmit() {
    if (this.hasSubmitTarget) {
      this.submitTarget.disabled = !this.valid();
    }
  }

  valid() {
    return this.fieldTargets.every(field => (
      (field.value.length > field.minLength) &&
      (field.value.length < field.maxLength)
    ));
  }
}
